// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"c359f13c","296":"fb6fd4dc"}[chunkId] + ".chunk.js";
};